import { render, staticRenderFns } from "./keys.vue?vue&type=template&id=3bb8cb28&"
import script from "./keys.vue?vue&type=script&lang=js&"
export * from "./keys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports